import { useState, useEffect } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { getUnitMeasureById, updateUnitMeasure } from '../../services/Other/GeneralQueries';

function EditUnitsModal({ unitMeasuresId, show, handleClose, handleReload }) {
  const [formData, setFormData] = useState({
    id: 0,
    name: '',
    abbreviation: '',
    isActive: false
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleUpdateUnitMeasure = () => {
    let pendingInputs = [];

    if (!formData.name) {
      pendingInputs.push("Nombre")
    }

    if (!formData.abbreviation) {
      pendingInputs.push("Abreviatura")
    }

    if (pendingInputs.length == 0) {
      updateUnitMeasure(formData.id, formData.name, formData.abbreviation, formData.isActive).then(unitResult => {
        toast.success('Unidad actualizada correctamente');
        handleClose();
        handleReload();
      });
    }
    else {
      toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
    }
  }

  useEffect(() => {
    if (show) {
      getUnitMeasureById(unitMeasuresId).then(obj => {
        setFormData({
          id: obj.id,
          name: obj.name,
          abbreviation: obj.abbreviation,
          isActive: obj.isActive
        });
      })
    }
  }, [show]);

  return (
    <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Actualizar unidad</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xl={12} className=' p-2'  >
            <Form.Label>Nombre:</Form.Label>
            <Form.Group controlId="">
              <Form.Control
                type="text"
                name="name"
                placeholder='Nombre de la unidad'
                value={formData.name}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xl={12} className=' p-2'  >
            <Form.Label>Abreviatura:</Form.Label>
            <Form.Group controlId="">
              <Form.Control
                type="text"
                name="abbreviation"
                placeholder='Abreviatura de la unidad'
                value={formData.abbreviation}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleUpdateUnitMeasure}>
          Actualizar
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditUnitsModal;